import styled from 'styled-components';
import { LoadingStrip } from '../../../common/components/LoadingStrip/LoadingStrip';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { FONT_STACK, FontWeight } from '../../../common/styles/constants';
import { onMobile } from '../../../common/styles/onMobile';

export const ResultLoadingView = styled.div`
  ${FONT_STACK}
  margin-inline-end: 90px;
  padding-top: 40px;
  width: 592px;

  ${onMobile} {
    margin-inline-end: 0px;
    width: 100%;
  }
`;

export const AdventureTime = styled.div`
  color: ${ThemeColours.black};
  font-size: 22px;
  font-weight: ${FontWeight.BOLD};
  line-height: 1.27em;
  margin-bottom: 16px;
`;

export const Count = styled(LoadingStrip)`
  display: flex;
  height: 14px;
  margin-bottom: 32px;
  max-width: 256px;

  ${onMobile} {
    margin-inline-start: 8px;
  }
`;

// Intended to fill width of parent
export const Card = styled(LoadingStrip)`
  display: flex;
  height: 256px;
  margin-bottom: 16px;
`;
